import React from 'react'
import { useSignupSession } from '../../hooks'
import { V3ContainerSkeleton } from '../../flows/v3/V3Container/v3ContainerSkeleton'

export const SignupSkeleton = () => {
  const { showSkeleton } = useSignupSession()
  return showSkeleton ? <V3ContainerSkeleton /> : null
}
